import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import {
  HomeTabStateType,
  HomeTabType,
  SlotPositionType,
} from 'features/MultiCategory/@types/homeTab'

export const SLICE_NAME = 'multiCategoryHomeTab'

export const initialState: HomeTabStateType = {
  isLoading: false,
  slotPositions: [],
  isSlotPositionsLoading: false,
  list: [],
  pagination: {
    pageSize: 20,
    pageIndex: 0,
    numberOfElements: 0,
  },
  query: {
    name: '',
    status: '',
    type: '',
  },
  showMulticategoryWarning: false,
}

export type SetListPayloadType = {
  list: HomeTabType[]
  numberOfElements: number
  showMulticategoryWarning: boolean
}

const multiCategoryHomeTab = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    resetState: () => initialState,
    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload
    },
    setQuery: (state, { payload }: PayloadAction<HomeTabStateType['query']>) => {
      state.query = { ...state.query, ...payload }
      state.pagination.pageIndex = 0
    },
    setPagination: (state, { payload }: PayloadAction<Partial<HomeTabStateType['pagination']>>) => {
      state.pagination = { ...state.pagination, ...payload }
    },
    setList: (state, { payload }: PayloadAction<SetListPayloadType>) => {
      state.list = payload.list
      state.pagination.numberOfElements = payload.numberOfElements
      state.showMulticategoryWarning = payload.showMulticategoryWarning
    },
    setSlotPositions: (state, { payload }: PayloadAction<SlotPositionType[]>) => {
      state.slotPositions = payload
    },
    setIsSlotPositionsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isSlotPositionsLoading = payload
    },
  },
})

export const {
  resetState,
  setIsLoading,
  setQuery,
  setPagination,
  setList,
  setSlotPositions,
  setIsSlotPositionsLoading,
} = multiCategoryHomeTab.actions
export default multiCategoryHomeTab.reducer
